import { AfterViewInit, Component } from '@angular/core';

import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { RecaptchaErrorParameters } from 'ng-recaptcha';
import { map, Observable, of, tap } from 'rxjs';

import { RECAPTCHA_FORBIDDEN } from '@valk-nx/core/lib/core';

@Component({
	selector: 'formly-field-recaptcha-v2-fallback',
	template: `
		@if (usingV2$ | async) {
			<re-captcha
				#recaptcha
				[errorMode]="to['errorMode']"
				[siteKey]="to['siteKey']"
				[size]="to['size']"
				(error)="onError($event)"
				(resolved)="onResolve($event)"
				class="my-4 block"
				ngDefaultControl
			/>
		}
	`,
	standalone: false,
})
export class RecaptchaV2FallbackComponent
	extends FieldType<FieldTypeConfig>
	implements AfterViewInit
{
	usingV2$: Observable<boolean>;

	constructor() {
		super();
	}

	ngAfterViewInit() {
		const fallbackTrigger = this.field.props['fallbackToV2Trigger'];
		if (fallbackTrigger) {
			this.usingV2$ = fallbackTrigger.pipe(
				tap(() => this.formControl.patchValue('')),
				map((val) => val === RECAPTCHA_FORBIDDEN),
			);
		} else {
			this.usingV2$ = of(true);
		}
	}

	onResolve(captchaResponse: string): void {
		this.formControl.patchValue(captchaResponse);
	}

	onError(errorDetails: RecaptchaErrorParameters): void {
		console.warn(`reCAPTCHA error: ${errorDetails}`);
	}
}
